import * as React from 'react';
import { Modal } from '../../../Modal';
import { TaxDeduction } from '../../../TaxDeduction';
import * as main from '../styles/main.module.scss';
import * as cost from '../styles/cost.module.scss';
export const Cost = ({ widgetStandart, widgetPremium, sravni }) => {
  const [showModalStandart, setShowModalStandart] = React.useState(false);
  const [showModalPremium, setShowModalPremium] = React.useState(false);

  return (
    <section className={cost.cost} id="cost">
      <div className="container">
        <div className={`row ${cost.cost__row}`}>
          <div className={`col-12 col-lg-4 ${cost.cost__col}`}>
            <div className={`${cost.cost__item} ${cost.cost__item_1}`}>
              <div className={cost.cost__item_header}>
                <div className={cost.cost__item_title}>
                  <span>Standart</span>
                  edition
                </div>
              </div>
              <div className={cost.cost__item_body}>
                <ul className={cost.cost__item_list}>
                  <li>Доступ к курсу на&nbsp;1&nbsp;год</li>
                  <li>Доступ ко&nbsp;всем урокам Вашего уровня сложности</li>
                  <li>Поддержка на&nbsp;платформе</li>
                  <li>Наборы популярных слов по&nbsp;тематикам</li>
                  <li>Модуль Фонетика: чтение и&nbsp;произношение</li>
                  <li>Сертификат с&nbsp;результатом тестирования</li>
                </ul>
                <div className={cost.newcost}>69&nbsp;900&nbsp;₽</div>
                <button
                  onClick={() => {
                    setShowModalStandart(true);
                  }}
                  className={`${main.mainBtn} ${cost.cost__item_btn}`}
                >
                  Купить курс
                </button>
              </div>
            </div>
          </div>

          <div className={`col-12 col-lg-4 ${cost.cost__col}`}>
            <div className={`${cost.cost__item} ${cost.cost__item_3}`}>
              <div className={cost.cost__item_header}>
                <div className={cost.cost__item_title}>
                  <span>Premium</span>
                  edition
                </div>
              </div>
              <div className={cost.cost__item_body}>
                <ul className={cost.cost__item_list}>
                  <li>Доступ к курсу на&nbsp;1&nbsp;год</li>
                  <li>Доступ ко&nbsp;всем урокам Вашего уровня сложности</li>
                  <li>Поддержка на&nbsp;платформе</li>
                  <li>Наборы популярных слов по&nbsp;тематикам</li>
                  <li>Модуль Фонетика: чтение и&nbsp;произношение</li>
                  <li>Сертификат с&nbsp;результатом тестирования</li>
                  <li>
                    <strong>15&nbsp;индивидуальных занятий (Zoom)</strong>
                  </li>
                </ul>
                <div className={cost.newcost}>114&nbsp;900&nbsp;₽</div>
                <button
                  onClick={() => {
                    setShowModalPremium(true);
                  }}
                  className={`${main.mainBtn} ${cost.cost__item_btn}`}
                >
                  Купить курс
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className={cost.cost__installment}>
          <p className={cost.cost__installment_text}>
            Курс можно приобрести в рассрочку на 6/10/12 месяцев и оплатить материнским капиталом{' '}
          </p>
        </div>

        <div className={cost.cost__installment}>
          <TaxDeduction className={cost.cost__installment_text} align={'center'} linkInner={sravni} />
        </div>
      </div>
      <Modal
        open={showModalStandart}
        onClose={() => {
          setShowModalStandart(false);
        }}
      >
        {widgetStandart}
      </Modal>

      <Modal
        open={showModalPremium}
        onClose={() => {
          setShowModalPremium(false);
        }}
      >
        {widgetPremium}
      </Modal>
    </section>
  );
};
